export class ProfileSensoryProfileType {
  static UNDEFINED = -1;
  static RANGE = 1;
}
